/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {

            init: function() {
                // JavaScript to be fired on all pages
                // fix console.log bug on IE8
                if (typeof console === "undefined") {
                    console = {
                        log: function() {}
                    };
                }
                //end fix console.log bug on IE8                
                // display none the helper that tells you what template is being loaded into the page
                $("body > p:contains('Rendered template:')").css("display", "none");

                $( "table" ).wrap( "<div class='table-responsive'></div>" );


                $( ".hidden_courses" ).hide();
                $( ".link_to_course_page" ).click(function () {
                  if ( $(this).next().is( ":hidden" ) ) { 
                    $(this).next().slideDown( "slow" );
                  } else {                    
                    $(this).next().slideUp( "slow" );
                  }
                });

                $(document).ready(function(){
                    $(".translate_button").click(function(){
                        $(".header_google").slideToggle("slow");
                    });
                });





                        /* jshint ignore:start */
var initPhotoSwipeFromDOM = function(gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            childElements,
            linkEl,
            size,
            item;

        for(var i = 0; i < numNodes; i++) {


            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes 
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element
            
            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };

            

            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML; 
            }
 
            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            } 
           
            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // Code for fixing surge.dev:3000 issue.

    $("a").on("click", function(){

        var currentURL = $(this).attr("href");
        if (currentURL.toLowerCase().indexOf("surge.dev") >= 0 && currentURL.toLowerCase().indexOf("wp-admin") <= 0) {
            var currentURL = currentURL.replace(document.location.hostname, document.location.hostname + ":3000");
            window.location.href = currentURL;
            return false;
        }
    });

    // alert(document.location.hostname); 

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }


        // find index of clicked item
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) { 
                continue; 
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if(index >= 0) {
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        if(!params.hasOwnProperty('pid')) {
            return params;
        }
        params.pid = parseInt(params.pid, 10);
        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {
            index: index,

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of docs for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect(); 

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            },

            // history & focus options are disabled on CodePen
            // remove these lines in real life: 
           history: false,
           focus: false 
        
        //,
      //  showHideOpacity:true

        };

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid > 0 && hashData.gid > 0) {
        openPhotoSwipe( hashData.pid - 1 ,  galleryElements[ hashData.gid - 1 ], true );
    }
};
                        /* jshint ignore:end */


// execute above function
initPhotoSwipeFromDOM('.my-simple-gallery');

                // ACF

                //ACF fill title field
                //used when a form is being filled on the front end. e.g testimonial...
                //It inserts a secondery field into the post title field and hides post title
                $("#acf-field_54ee353e2cace").keyup(function(event) {
                    var val = "";
                    val = $(this).val();
                    $("#acf-_post_title").val(val);
                });
                $("#acf-_post_title").parent().parent().parent().hide();
                //ACF change post updated text
                //Remove title and show updated text on submit.               
                /*                if ($("div#message.updated p:contains('Post updated')").length) {
                                    $("div#message.updated p").text("Thank you for your feedback");
                                    $("#submit_your_feedback").hide();
                                }*/



                //WOOCOMMERCE
                //woocommerce fix for course cols
                /*  $(".courses60").wrapAll("<div class='col-xs-12 col-sm-12 col-md-7 col-lg-7' />");
                  $(".courses40").wrapAll("<div class='col-xs-12 col-sm-12 col-md-5 col-lg-5' />");*/
                // end woocommerce fix for course cols
                /*  $(document).on({
                      mouseenter: function() {
                          $(".show_minicart").stop().slideToggle();
                      },
                      mouseleave: function() {

                          $(".show_minicart").stop().slideToggle();

                      }
                  }, ".hover_me_to_show_minicart"); //pass the element as an argument to .on*/

                // funcky number spinner
                /*                $.fn.spinner = function() {
                                    this.each(function() {
                                        var el = $(this);

                                        // add elements
                                        el.wrap('<span class="spinner"></span>');
                                        el.before('<span class="sub">-</span>');
                                        el.after('<span class="add">+</span>');

                                        // substract
                                        el.parent().on('click', '.sub', function() {
                                            console.log(el.val());
                                            console.log(parseInt(el.attr('min')));
                                            if (el.val() > parseInt(el.attr('min'))) {
                                                el.val(function(i, oldval) {
                                                    return --oldval;
                                                });
                                            }
                                        });

                                        // increment
                                        el.parent().on('click', '.add', function() {
                                            //console.log(el.val());
                                            //console.log(parseInt(el.attr('max')));

                                            if (el.val() < parseInt(el.attr('max')) || isNaN(parseInt(el.attr('max')))) {
                                                el.val(function(i, oldval) {
                                                    //console.log(oldval+" asdas");
                                                    return ++oldval;
                                                });
                                            }
                                        });

                                    });
                                };
                                $('input[type=number]').spinner();*/
                // funcky number spinner end

                // BOOTSTRAP DROPDOWNS
                // make multi dropdowns work

                // make caret go back how it was when clicking outside of the nav menu
                $('html').click(function() {
                    $(".caret").css({
                        "border-bottom": "0px solid",
                        "border-top": "4px solid"
                    });
                });
                $('nav[role="navigation"]').click(function(event) {
                    event.stopPropagation();
                });

                // add the dropdown classes that get missed out in the php loop
                $(".dropdown > a:not(.dropdown-toggle)")
                    .attr("dropdown-toggle", "dropdown")
                    .addClass("dropdown-toggle")
                    .append('<b class="caret"></b>');

                // what to do on click to open and close the extra dropdowns
                $(".dropdown > a").click(function() {
                    if ($(this).parent().hasClass("open")) {
                        $(this).parent().parent().find(".open").removeClass("open");
                        $(this).parent().parent().find(".caret").css({
                            "border-bottom": "0px solid",
                            "border-top": "4px solid"
                        });
                    } else {
                        $(this).parent().parent().find(".open").removeClass("open");
                        $(this).parent().addClass("open");
                        $(this).find(".caret").css({
                            "border-bottom": "4px solid",
                            "border-top": "0px solid"
                        });
                    }

                    // dont action the page load...
                    return false;
                });

                // make footer go to the bottom of page...
                var last_run_height = 0,
                    wordpress_admin_bar;
                if ($('body').hasClass('logged-in')) {
                    wordpress_admin_bar = 32;
                } else {
                    wordpress_admin_bar = 0;
                }

                function doFooter() {
                    var window_height = window.innerHeight,
                        margin_push = 0,
                        current_margin = parseInt($("footer[role='contentinfo']").css("marginTop").replace('px', ''), 10),
                        overall_height_margin = document.body.offsetHeight - current_margin,
                        overall_height = document.body.offsetHeight;
             /*       console.log("offsetHeight: " + document.body.offsetHeight);
                    console.log("overall-height: " + overall_height_margin);
                    console.log("window-height: " + window_height);
                    console.log("current-margin: " + current_margin);*/
                    if (last_run_height !== 0 && last_run_height <= overall_height) {
                        $("div[role='document'] *").promise().done(function() {
                            if (overall_height_margin < window_height) {
                                $("footer[role='contentinfo']").stop().animate({
                                    "margin-top": "0px"
                                }, 0);
                                //console.log("move if");
                            }
                        });
                        if (overall_height_margin < window_height) {
                            margin_push = window_height - overall_height_margin;
                            console.log("bottom if");
                            $("footer[role='contentinfo']").promise().done(function() {
                                $(this).animate({
                                    "margin-top": Math.round(margin_push - wordpress_admin_bar) + "px"
                                }, 0);
                                //console.log("bottom if");
                            });
                        }
                    } else {
                        if (overall_height_margin <= window_height) {
                            margin_push = window_height - overall_height_margin;
                            $("footer[role='contentinfo']").promise().done(function() {
                                $(this).animate({
                                    "margin-top": Math.round(margin_push - wordpress_admin_bar) + "px"
                                }, 0);
                                //console.log("bottom if else");
                            });
                        }

                    }
                    last_run_height = overall_height;
                }

                $(window).load(function() {
                    doFooter();
                    new ResizeSensor($("div[role='document']"), function() { //http://marcj.github.io/css-element-queries/
                        doFooter();
                    });
                });
                /*                setTimeout(function() {

                                    $(".main p").animate({
                                        "height": "300px"
                                    }, 1000);

                                }, 1000);*/

                $(".website-block").on("mouseenter", function() {
                    $(this).find(".website-block-overlay").stop().animate({

                        height: "200px",
                        opacity: 0.9
                    }, 500);

                }).on("mouseleave", function() {
                    $(this).find(".website-block-overlay").stop().animate({

                        height: "0px",
                        opacity: 0
                    }, 500);
                });

                $(".template-site-wrapper").on("mouseenter", function() {
                    var imgHeight = $(this).find(".img-responsive").height();
                
                    $(this).find(".template-site-overlay").stop().animate({
                        height: imgHeight + "px",
                        opacity: 0.9
                    }, 500);
                

                }).on("mouseleave", function() {
                    $(this).find(".template-site-overlay").stop().animate({

                        height: "0px",
                        opacity: 0
                    }, 500);
                });

                var checkboxFilter = {

                    // Declare any variables we will need as properties of the object

                    $filters: null,
                    $reset: null,
                    groups: [],
                    outputArray: [],
                    outputString: '',

                    // The "init" method will run on document ready and cache any jQuery objects we will need.

                    init: function() {
                        var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "checkboxFilter" object so that we can share methods and properties between all parts of the object.

                        self.$filters = $('#Filters');
                        self.$reset = $('#Reset');
                        self.$container = $('#Container');

                        self.$filters.find('fieldset').each(function() {
                            self.groups.push({
                                $inputs: $(this).find('input'),
                                active: [],
                                tracker: false
                            });
                        });

                        self.bindHandlers();
                    },

                    // The "bindHandlers" method will listen for whenever a form value changes. 

                    bindHandlers: function() {
                        var self = this;

                        self.$filters.on('change', function() {
                            self.parseFilters();
                        });

                        self.$reset.on('click', function(e) {
                            e.preventDefault();
                            self.$filters[0].reset();
                            self.parseFilters();
                        });
                    },

                    // The parseFilters method checks which filters are active in each group:

                    parseFilters: function() {
                        var self = this;

                        // loop through each filter group and add active filters to arrays

                        /* jshint ignore:start */
                        for (var i = 0, group; group = self.groups[i]; i++) {
                            group.active = []; // reset arrays
                            group.$inputs.each(function() {
                                $(this).is(':checked') && group.active.push(this.value);
                            });
                            group.active.length && (group.tracker = 0);
                        }
                        /* jshint ignore:end */
                        self.concatenate();
                    },

                    // The "concatenate" method will crawl through each group, concatenating filters as desired:

                    concatenate: function() {
                        var self = this,
                            cache = '',
                            crawled = false,
                            checkTrackers = function() {
                                var done = 0;
                                /* jshint ignore:start */
                                for (var i = 0, group; group = self.groups[i]; i++) {
                                    (group.tracker === false) && done++;
                                }
                                /* jshint ignore:end */
                                return (done < self.groups.length);
                            },
                            crawl = function() {
                                /* jshint ignore:start */
                                for (var i = 0, group; group = self.groups[i]; i++) {
                                    group.active[group.tracker] && (cache += group.active[group.tracker]);

                                    if (i === self.groups.length - 1) {
                                        self.outputArray.push(cache);
                                        cache = '';
                                        updateTrackers();
                                    }
                                }
                                /* jshint ignore:end */
                            },
                            updateTrackers = function() {
                                for (var i = self.groups.length - 1; i > -1; i--) {
                                    var group = self.groups[i];

                                    if (group.active[group.tracker + 1]) {
                                        group.tracker++;
                                        break;
                                    } else if (i > 0) {
                                        /* jshint ignore:start */
                                        group.tracker && (group.tracker = 0);
                                        /* jshint ignore:end */
                                    } else {
                                        crawled = true;
                                    }
                                }
                            };

                        self.outputArray = []; // reset output array

                        do {
                            crawl();
                        }
                        while (!crawled && checkTrackers());

                        self.outputString = self.outputArray.join();

                        // If the output string is empty, show all rather than none:

                        /* jshint ignore:start */
                        !self.outputString.length && (self.outputString = 'all');
                        /* jshint ignore:end */

                        //console.log(self.outputString); 

                        // ^ we can check the console here to take a look at the filter string that is produced

                        // Send the output string to MixItUp via the 'filter' method:

                        // helpchrisplz edits

                        var extraDropDownColours = [];
                        $(".dropdownSort").each(function() {
                            if ($("option:selected", this).val().substring(1) !== "") {
                                extraDropDownColours.push($("option:selected", this).val().substring(1));
                            }
                        });

                        $.each(extraDropDownColours, function(index, item) {
                            //alert(item);    
                            if (item !== "select") {

                                if (self.outputString === "all") {
                                    self.outputString += ',.' + item.toLowerCase();
                                } else {

                                    // Removes all of the commas within your string
                                    var suckIt = self.outputString.split(',');

                                    // Iterate through each value
                                    self.outputString = "";
                                    for (var i = 0; i < suckIt.length; i++) {
                                        self.outputString += suckIt[i] + '.' + item.toLowerCase() + ',';
                                    }

                                    if (self.outputString.substring(self.outputString.length - 1) === ",") {
                                        self.outputString = self.outputString.substring(0, self.outputString.length - 1);
                                    }

                                }
                            }

                        }); //each

                        //  end helpchrisplz edits

                        if (self.$container.mixItUp('isLoaded')) {
                            console.log(self.outputString);
                            self.$container.mixItUp('filter', self.outputString);

                        }
                    }
                };

                // On document ready, initialise our code.

                $(function() {

                    // Initialize checkboxFilter code

                    checkboxFilter.init();

                    // Instantiate MixItUp

                    $('#Container').mixItUp({
                        controls: {
                            enable: false // we won't be needing these
                        },
                        animation: {
                            easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
                            duration: 600
                        },
                        load: {
                            filter: 'all'
                        }
                    });
                });





// seo page


$(function(){
  var $container = $('#seo-container'),
      $controls = $('.seo-controls');
  
  $container.mixItUp({
    animation: {
      duration: 700,
      effects: 'fade translateY(600%) stagger(35ms)',
      easing: 'cubic-bezier(0.86, 0, 0.07, 1)',
      reverseOut: true
    },
    controls: {
      enable: false
    }
  });
  
  $controls.on('click', '.filter', function(){
    var $btn = $(this),
        filter = $btn.attr('data-filter');
    
    $btn.addClass('active').siblings().removeClass('active');

    $container.mixItUp('filter', 'none', function(){
      $container.mixItUp('filter', filter);
    });
  });
  
});






















            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {
                //jquery by helpchrisplz - chris sowerby

                var newNumber;
                var i;
                $autoSlideChange = 3999000;
                $childNumbers = 0; // this must be 0
                $useSlideBtns = false;
                $slideEffect = "fade"; // fade or slide
                var refreshInterval;

                if ($useSlideBtns === true) {
                    $('#basicSlider > ul li').each(function() {
                        $childNumbers++;

                        var addSlideBtn = "<span class='slidechildNumber" + $childNumbers + "'>" + $childNumbers + "</span>";

                        //#slideBtns span
                        $(this).addClass('slidechildNumber' + $childNumbers);
                        $('#slideBtns').append(addSlideBtn);
                    });
                    $("#slideBtns span:nth-child(1)").addClass("slideBtns");
                }


                function update() {
                    moveRight();
                }

                //call resizeMyWindow function when the window is resized
                var basicSliderResizeTimer;
                $(window).resize(function() {
                    clearTimeout(basicSliderResizeTimer);
                    basicSliderResizeTimer = setTimeout(basicSliderResizeMyWindow, 100);
                });

                function basicSliderResizeMyWindow() {
                    slideCount = $('#basicSlider > ul li').length;
                    slideWidth = $('#basicSlider > ul li').width();

                    var theParentWidth = $("#basicSlider").parent().width();

                    slideWidth = theParentWidth;
                    $('#basicSlider > ul li').css("width", slideWidth);

                    slideHeight = $('#basicSlider > ul > li:nth-child(2) > ul').height() + 20;
                    sliderUlWidth = slideCount * slideWidth;

                    $('#basicSlider').css({
                        width: slideWidth,
                        height: slideHeight
                    });

                    $('#basicSlider > ul').css({
                        width: sliderUlWidth,
                        marginLeft: -slideWidth
                    });


                }
                $('#basicSlider > ul li:last-child').prependTo('#basicSlider > ul');
                basicSliderResizeMyWindow();


                function doNextBtnRight() {
                    $("#slideBtns").find(".slideBtns").removeClass("slideBtns")
                        .next().addClass("slideBtns");

                    if (!$("#slideBtns span").hasClass("slideBtns")) {
                        $("#slideBtns span:nth-child(1)").addClass("slideBtns");
                    }
                }

                function doNextBtnLeft() {
                    $("#slideBtns").find(".slideBtns").removeClass("slideBtns")
                        .prev().addClass("slideBtns");

                    if (!$("#slideBtns span").hasClass("slideBtns")) {
                        $("#slideBtns span:last-child").addClass("slideBtns");
                    }
                }

                function setTheHight() {
                    //used if content is difrent sizes. 
                    slideHeight = $('#basicSlider > ul > li:nth-child(2) > ul').height() + 20;
                    $('#basicSlider').animate({
                        height: slideHeight
                    }, 100);

                }

                /*function setOverAllContentHeight () {
                  
                  contentPush
                }*/


                function moveLeft(no) {
                    if (!no) {
                        doNextBtnLeft();
                    }
                    if ($slideEffect === "fade") {
                        $('#basicSlider > ul').animate({
                            opacity: 0.0
                        }, 400, function() {
                            $('#basicSlider > ul li:last-child').prependTo('#basicSlider > ul');
                            $('#basicSlider > ul').css('opacity', '1.0');
                        });
                    }
                    if ($slideEffect === "slide") {
                        $('#basicSlider > ul').animate({
                            left: +slideWidth
                        }, 400, function() {
                            $('#basicSlider > ul li:last-child').prependTo('#basicSlider > ul');
                            $('#basicSlider > ul').css('left', '0');
                        });
                    }

                    setTimeout(function() {
                        setTheHight();
                    }, 420);
                }

                function moveRight(no) {
                    if (!no) {
                        doNextBtnRight();
                    }

                    if ($slideEffect === "fade") {
                        $('#basicSlider > ul').animate({
                            opacity: 0.0
                        }, 400, function() {
                            $('#basicSlider > ul li:first-child').appendTo('#basicSlider > ul');
                            $('#basicSlider > ul').css('opacity', '1.0');
                        });
                    }

                    if ($slideEffect === "slide") {
                        $('#basicSlider > ul').animate({
                            left: -slideWidth
                        }, 400, function() {
                            $('#basicSlider > ul li:first-child').appendTo('#basicSlider > ul');
                            $('#basicSlider > ul').css('left', '0');
                        });
                    }


                    setTimeout(function() {
                        setTheHight();
                    }, 420);
                }

                $('.control_prev').click(function() {
                    clearInterval(refreshInterval);
                    moveLeft();
                    refreshInterval = setInterval(update, $autoSlideChange);
                });

                $('.control_next').click(function() {
                    clearInterval(refreshInterval);
                    moveRight();
                    refreshInterval = setInterval(update, $autoSlideChange);
                });

                // this block of code is to change the slide if $useSlideBtns is set to true.
                $('#slideBtns span').click(function() {
                    clearInterval(refreshInterval);
                    // the one you click on
                    var numberFromCurrentClass = $(this).prevAll().length + 1;

                    // the one that is active
                    var numberFromClickedToEnd = $("#slideBtns .slideBtns").prevAll().length + 1;

                    //remove old class and update to new position
                    $("#slideBtns .slideBtns").removeClass("slideBtns");
                    $(this).addClass("slideBtns");

                    //console.log("numberFromCurrentClass "+numberFromCurrentClass)
                    //console.log("numberFromClickedToEnd "+numberFromClickedToEnd)
                    // if i click on 1 but 2 is active becasue the clicked on is less than the active we need to call move left else move right by the amount of difference between the 2 numbers.

                    if (numberFromCurrentClass < numberFromClickedToEnd) {
                        newNumber = numberFromClickedToEnd - numberFromCurrentClass;
                        //console.log("minus = "+newNumber)

                        for (i = 0; i < newNumber; i++) {
                            if (i === 1) {
                                moveLeft("no");
                            } else {
                                /* jshint ignore:start */
                                setTimeout(function() {
                                    moveLeft("no");
                                }, 500);
                                /* jshint ignore:end */
                            }
                        }

                    } else {
                        newNumber = numberFromCurrentClass - numberFromClickedToEnd;
                        //console.log("plus = "+newNumber)

                        for (i = 0; i < newNumber; i++) {
                            if (i === 1) {
                                moveRight("no");
                            } else {
                                /* jshint ignore:start */
                                setTimeout(function() {

                                    moveRight("no");
                                }, 500);
                                /* jshint ignore:end */
                            }
                        }

                    }
                    refreshInterval = setInterval(update, $autoSlideChange);
                });


                refreshInterval = setInterval(update, $autoSlideChange);
            },

            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // To keep our code clean and modular, all custom functionality will be contained inside a single object literal called "checkboxFilter".

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
